import { render, staticRenderFns } from "./index.vue?vue&type=template&id=97faf44c&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=97faf44c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97faf44c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\git\\platform_el\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('97faf44c')) {
      api.createRecord('97faf44c', component.options)
    } else {
      api.reload('97faf44c', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=97faf44c&scoped=true", function () {
      api.rerender('97faf44c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/panel/appTemplateMarket/log/index.vue"
export default component.exports